import script from "./CreateBankPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateBankPage.vue?vue&type=script&setup=true&lang=js"

import "./CreateBankPage.vue?vue&type=style&index=0&id=35a469d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a469d3"]])

export default __exports__